import http from "../helpers/http";

export class ScheduleService {
    static new() {
        return new ScheduleService();
    };

    async arriveSchedule(place, schedule) {
        let idSched = schedule.id_sched;
        let isSchedArrive = schedule.sched_arrive

        let payload = {};
        if (schedule.is_marketplace && !isSchedArrive) {
            const result = await Swal.fire({
                title: 'Palavra-chave',
                input: 'textarea',
                icon: 'question',
                inputLabel: 'O paciente recebeu via WhatsApp ou no app.',
                allowEscapeKey: true,
                showCloseButton: true,
                allowOutsideClick: false,
                confirmButtonColor: 'rgba(120,15,90,0.8)',
                confirmButtonText: "CONFIRMAR CHEGADA E RECEBER HOJE",
                showDenyButton: true,
                inputPlaceholder: 'Ex. VIRTUDE.',
                denyButtonText: `CONFIRMAR CHEGADA SEM PALAVRA-CHAVE`,
                denyButtonColor: "rgb(83,136,235)",
                footer: '<small><i>Receba o seu pagamento ainda hoje informando a palavra-chave.</i></small>',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Informe a palavra-chave.'
                    }
                }
            });

            if (result.isDismissed) {
                return;
            }

            const keyword = result.value;
            if (keyword) {
                payload = {
                    ...payload,
                    keyword: keyword,
                }
            }
        }

        let action = isSchedArrive ? 'not-arrive' : 'arrive';
        return http.patch(`/places/${place.id_place}/schedules/${idSched}/${action}`, payload);
    };

}